module.exports = __webpack_public_path__ + "img/personalised-graduation-clip.47c18b3e.jpg";